import { Button, withStyles } from '@material-ui/core';

const SubmitButton = withStyles({
  root: {
    minWidth: '30px',
    color: '#fff',
    fontWeight: 700,
    padding: '2px 2rem',
    marginLeft: 15,
    borderRadius: 5,
    fontSize: '1.1rem',
    background: '#00B5E2',
    '&:active': {
      background: '#00B4E0',
    },
  },
  disabled: {
    background: '#C4C4C4',
  },
})(Button);

export default SubmitButton;
